<template>
    <div>
        <div class="app-body">
            <page-header></page-header>
            <div class="allContain xy-between">
                <nav-bar></nav-bar>
                <div class="accountSet">
                    <div class="tit font-size16 jf">
                        <div class="btns yx-between" @click="Resources">
                            <div>我的资源</div>
                            <div
                                v-if="active === 'resources'"
                                class="tab"
                            ></div>
                        </div>

                        <div class="btns yx-between" @click="Recharge">
                            <div>充值记录</div>
                            <div v-if="active === 'recharge'" class="tab"></div>
                        </div>

                        <div class="btns yx-between" @click="Custom">
                            <div>消费记录</div>
                            <div v-if="active === 'consume'" class="tab"></div>
                        </div>
                    </div>

                    <div>
                        <!--我的资源-->
                        <div v-if="active === 'resources'" class="information">
                            <personResources></personResources>
                        </div>
                        <!--我的资源-->

                        <!--充值记录-->
                        <div v-if="active === 'recharge'" class="customTitle">
                            <personRecharge></personRecharge>
                        </div>
                        <!--充值记录-->

                        <!--消费记录-->
                        <div v-if="active === 'consume'" class="customTitle">
                            <personConsume></personConsume>
                        </div>
                        <!--消费记录-->
                    </div>
                </div>
            </div>
        </div>
        <bottom-ground></bottom-ground>
    </div>
</template>

<script>
import { accountLogin } from "@/api/user";
import PageHeader from "@/components/header";
import NavBar from "@/components/personCenter/nav";
import personResources from "@/components/member/personResources";
import personRecharge from "@/components/member/personRecharge";
import personConsume from "@/components/member/personConsume";
import BottomGround from "@/components/bottomnav";
export default {
    components: {
        PageHeader,
        NavBar,
        personResources,
        personRecharge,
        personConsume,
        BottomGround,
    },
    created() {},
    mounted() {
        console.log(
            "111:" + this.$route.query.action
                ? this.$route.query.action
                : "resources"
        );
    },
    data() {
        return {
            currentNav: "collect",
            active: this.$route.query.action
                ? this.$route.query.action
                : "resources",
        };
    },
    methods: {
        Resources() {
            this.active = "resources";
        },
        Recharge() {
            this.active = "recharge";
        },
        Custom() {
            this.active = "consume";
        },
    },
};
</script>

<style lang="less" scoped>
.allContain {
    width: 100%;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 30px;
    .accountSet {
        width: 940px;
        height: 830px;
        background-color: white;
        border-radius: 16px;

        .tit {
            padding: 20px 20px 0px 20px;
            box-sizing: border-box;
            border-bottom: 1px solid #e5e8ec;

            .btns {
                height: 35px;
                box-sizing: border-box;
                margin: 0 25px 0 25px;
                cursor: pointer;

                .tab {
                    width: 50px;
                    height: 4px;
                    background: #256cf4;
                    border-radius: 2px;
                }
            }
        }

        .information {
            padding: 20px 30px;
            box-sizing: border-box;

            .line {
                margin-bottom: 30px;

                span {
                    font-size: 16px;
                }

                .header {
                    width: 120px;
                    padding-right: 30px;
                    text-align: right;
                }

                ::v-deep .el-input__inner {
                    width: 350px;
                    height: 40px;
                    font-size: 14px;
                }
            }

            .saveBtn {
                width: 70px;
                height: 35px;
                margin-left: -18px;
                background: #256cf4;
                border-radius: 4px;
                color: white;
            }

            .fristLine {
                margin-top: 20px;
            }
        }

        .customTitle {
            padding: 20px 30px;
            box-sizing: border-box;
        }
        .detailBox {
            padding: 20px 30px;
            box-sizing: border-box;
        }
    }
}
</style>
